export default __webpack_public_path__ + "static/media/successTraining.a752b7de.svg";